@for (number of items; track $index) {
    <div class="marquee-card card"><div class="ghost-loader-card-animation"></div></div>
}
